// extracted by mini-css-extract-plugin
export var body = "_mb-0";
export var sectionHeader = "_mb-4";
export var shortcutColumns = "_mb-2";
export var shortcutList = "_mb-1";
export var shortcutSection = "_mb-3";